import $ from 'jquery';
import get from 'lodash/get';

import './elements.scss';
import './fields/validator';
import './fields/invalidate';
import './fields/error-summary';
import './fields/character-counter';
import './fields/radio-group-validator';

import './fields/floating-label-plugin';
import './fields/entry-error';
import './fields/select-creditcard';

window.initFloatingLabels = () => {
  $(document).ready(() => {
    $(document.querySelectorAll('[data-validate]'))
      .validator()
      .errorSummary();
    $(document.getElementsByClassName('character-counter-field')).characterCounter();
    $(document.getElementsByClassName('validate-radio-group')).radioGroupValidator({
      errorClassName: 'form-section__error',
    });
    $(document.querySelectorAll('[data-entry-error]')).entryError({
      requiredTemplate: get(window, 'rcProps.entryError.requiredTemplate', ''),
      invalidTemplate: get(window, 'rcProps.entryError.invalidTemplate', ''),
    });
    $(document.getElementsByClassName('floating-label')).floatingLabel();
    $(document.getElementsByClassName('js-select-credit-card')).selectCreditCard();
  });
};

$(document).ready(() => {
  if ($('body').attr('data-vue') !== 'true') {
    window.initFloatingLabels();
  }
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/elements.js